export default {"src":"/_next/static/media/twitterW.4062eb91.svg","height":48,"width":50,"blurWidth":0,"blurHeight":0};